import api from '~/services/api';

const BASE_URL = '/signed/empresa/administracao/gerenciamento/funcionario';

export async function findAll() {
  return api.get(`${BASE_URL}s`);
}

export async function findOne({ id }) {
  return api.get(BASE_URL, { params: { id } });
}

export async function create(payload) {
  return api.post(BASE_URL, payload);
}

export async function update(id, payload) {
  return api.put(BASE_URL, { id, ...payload });
}

export async function deleteOne({ id }) {
  return api.delete(BASE_URL, { data: { id } });
}

export default { findAll, findOne, create, update, deleteOne };
